import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../http/http.service';
import { StoreApiEndPoints } from 'src/app/app.config';
import { Observable, throwError } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  // public onHide = new EventEmitter<boolean>()
  private web_url: string = StoreApiEndPoints.apiEndpoint;
  private messageSource = new BehaviorSubject(JSON.parse((localStorage.getItem('user'))));
  currentMessage = this.messageSource.asObservable();

  private platfromsource = new BehaviorSubject<string>('');  // default value
  currentPlatform = this.platfromsource.asObservable();
  
  changePlatform(message: any) {
    console.log('inside shared service')
    console.log(message)
    this.platfromsource.next(message);
  }

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  constructor(
    private mock: HttpClient,
    private http: HttpService
  ) { }
 
  
  getRetailerStore(retailer_id, page, hideLoader= '', flag=''): Observable<any> {
    return this.http.get(this.web_url+'retailer-stores/'+retailer_id+'/?page='+page+'&flag='+flag, hideLoader)
      .map(this.extractData)
      .catch(this.handleError);
  }
  getActiveStore(search, page, hideLoader= ''): Observable<any> {
    return this.http.get(this.web_url+'active-stores/?page='+page+'&search='+search, hideLoader)
      .map(this.extractData)
      .catch(this.handleError);
  }

  removeNumberPrefixAddress(address_text:string){
    let final_string = '';
    final_string = address_text.replace(/[0-9]/g, '');
    return final_string ? final_string : '';
  }

  private extractData(res: Response) {
    if (res.ok && res.status === 200) {
      const body = res.json();
      return body || {};
    } else {
      return throwError('Error in api\'s (server)');
    }
  }

  // Handle Errors
  private handleError(error: any) {
    return throwError(error);
  }
}
